import { FC, useState } from 'react';

import { Send } from '@mui/icons-material';

import { useParams } from '@redwoodjs/router';

import { Flex } from 'src/components/Flex';
import { ModalBox } from 'src/components/ModalContent/Modal';
import ResendToBillingContactForm from 'src/features/finance/components/ResendToBillingContactForm/ResendToBillingContactForm';

interface ResendCreditNoteItemProps {
    billingContactEmailAddress: string;
}

export const ResendCreditNoteItem: FC<ResendCreditNoteItemProps> = ({
    billingContactEmailAddress,
}) => {
    const { id } = useParams();
    const [showModal, setShowModal] = useState(false);

    const onSubmit = (sender, billingContactEmailAddress, coverMessage) => {
        // TODO: use the id from useParams and resend credit note action
    };
    return (
        <>
            <Flex
                justifyContent="center"
                alignItems="center"
                color="white"
                bgcolor="#F39E4E"
                borderRadius="4px"
                padding="8px"
                sx={{ cursor: 'pointer' }}
                onClick={() => setShowModal(true)}
            >
                <Send height="24px" width="24px" />
            </Flex>
            {showModal && (
                <ModalBox
                    handleCloseModal={() => setShowModal(false)}
                    open={showModal}
                    title="Resend Credit Note Item"
                >
                    <ResendToBillingContactForm
                        billingContactEmailAddress={billingContactEmailAddress}
                        onSubmit={onSubmit}
                    />
                </ModalBox>
            )}
        </>
    );
};
